import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { ShieldX } from 'lucide-react';

export default function AccessDenied() {
  const { user } = useAuth();
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ backgroundColor: 'var(--bg-subtle)' }}>
      <div className="text-center max-w-sm" data-testid="access-denied-card">
        <ShieldX size={40} className="mx-auto mb-4" style={{ color: 'var(--text-muted)', opacity: 0.5 }} />
        <h1 className="text-2xl font-semibold mb-2" style={{ fontFamily: 'var(--font-serif)', color: 'var(--text)' }}>Access Restricted</h1>
        <p className="text-sm mb-6" style={{ color: 'var(--text-muted)' }}>You don’t have permission to view this page. This area is reserved for approved members.</p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button variant="outline" onClick={() => navigate(-1)} data-testid="access-denied-go-back-button" style={{ borderColor: 'var(--border-strong)' }}>Go Back</Button>
          {!user && <Button onClick={() => navigate('/register')} style={{ backgroundColor: 'var(--text)', color: 'white' }}>Apply for Membership</Button>}
          {user && user.role === 'applicant' && <Button onClick={() => navigate('/membership/status')} style={{ backgroundColor: 'var(--gold)', color: 'white' }}>View Application Status</Button>}
        </div>
      </div>
    </div>
  );
}
